export class ApiAdaptater {

	static singleAlbum(source) {
		const obj = {}

		obj.id = source.id
		obj.image = source.image
		obj.popularity = source.popularity
		obj.title = source.title
		obj.description = source.description
		obj.tracks = source.tracks
		obj.albums_same_artist = source.albums_same_artist

		for (let i = 0; i < obj.tracks.items.length; i++) {
			const album = JSON.parse(JSON.stringify(source))
			delete(album.tracks)
			obj.tracks.items[i].album = album
		}

		obj.product_type = source.product_type
		obj.tracks_count = source.tracks_count
		obj.copyright = source.copyright
		obj.artist = source.artist
		obj.composer = source.composer
		obj.label = source.label
		obj.articles = source.articles
		obj.goodies = source.goodies
		obj.duration = source.duration
		obj.genre = source.genre
		obj.media_count = source.media_count
		obj.hires = source.hires
		obj.released_at = source.released_at
		obj.maximum_technical_specifications = source.maximum_technical_specifications
		obj.maximum_bit_depth = source.maximum_bit_depth
		obj.maximum_channel_count = source.maximum_channel_count
		obj.maximum_sampling_rate = source.maximum_sampling_rate
		obj.awards = source.awards
		obj.genres_list = source.genres_list
		obj.downloadable = source.downloadable
		obj.streamable = source.streamable

		return obj
	}

	static singleArtist(source) {
		// on change pas l'objet artiste de l'api

		return source
	}

	static singlePlaylist(source) {
		return source
	}

	static singleTrack(source) {
		return source
	}
}



// WEBPACK FOOTER //
// ./src/utils/business/adapter/adaptaters.js